var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocumentIcon = function SvgDocumentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 .667A4.666 4.666 0 1 0 16 10a4.666 4.666 0 0 0 0-9.333Zm0 2.667a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM7.333 4.667A3.333 3.333 0 0 0 4 8c0 1.254.707 2.334 1.72 2.907.48.267 1.027.427 1.613.427.587 0 1.134-.16 1.614-.427.493-.28.906-.68 1.213-1.16a7.227 7.227 0 0 1-1.493-4.413V4.96a3.15 3.15 0 0 0-1.334-.293Zm17.334 0c-.48 0-.934.107-1.334.293v.374c0 1.6-.52 3.146-1.493 4.413.16.253.333.453.533.653a3.31 3.31 0 0 0 2.294.934c.586 0 1.133-.16 1.613-.427C27.293 10.334 28 9.254 28 8a3.333 3.333 0 0 0-3.333-3.333Zm-8.667 8c-3.12 0-9.333 1.56-9.333 4.667v2h18.666v-2c0-3.107-6.213-4.667-9.333-4.667Zm-9.72.733C3.707 13.707 0 15.014 0 17.334v2h4V16.76c0-1.346.92-2.466 2.28-3.36Zm19.44 0c1.36.894 2.28 2.014 2.28 3.36v2.574h4v-2c0-2.32-3.707-3.627-6.28-3.934ZM16 15.334c2.04 0 4.32.666 5.64 1.333H10.36c1.32-.667 3.6-1.333 5.64-1.333Z",
    fill: "#fff"
  })));
};

export default SvgDocumentIcon;